import React, { FC, useContext, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { isTouchDevice } from '../../../../utils/domUtils';
import { Hyperlink } from '../../../../components/Hyperlink';
import { UserContext } from '../../../../user/UserContext';
import { sendResultClickedEvent } from '../../../search-utils';
import { getCommentUrl } from './searchCommentUtils';
import { SearchComment } from './searchResultComment.types';
import { useRestrictedModal } from '../../../../components/modal/useRestrictedModal';

type Props = {
  comment: SearchComment;
  originalQueryKey: string;
};

export const SearchResultCommentSummary: FC<Props> = ({
  comment,
  originalQueryKey,
}) => {
  const { accessPremium } = useContext(UserContext);
  const { openRestrictedModal } = useRestrictedModal();

  const commentSummaryClicked = useCallback(
    (evt: React.MouseEvent<HTMLAnchorElement>) => {
      if (!accessPremium) {
        evt.preventDefault();
        openRestrictedModal({ source: 'excerpt_results_comment' });
      } else {
        sendResultClickedEvent(comment, originalQueryKey);
      }
    },
    [accessPremium, originalQueryKey],
  );

  const commentUrl = getCommentUrl(comment.url, accessPremium);
  return (
    <div className="excerpt_comment__comment__excerpt">
      {!isTouchDevice() && Boolean(comment.textShort) && (
        <p
          className="excerpt_comment__comment__excerpt__content"
          dangerouslySetInnerHTML={{ __html: comment.textShort }}
        />
      )}
      {isTouchDevice() && Boolean(comment.textShort) && (
        <Hyperlink
          {...(accessPremium ? { href: commentUrl, target: '_blank' } : {})}
          onClick={commentSummaryClicked}
          className="excerpt_comment__comment__excerpt__content"
          dangerouslySetInnerHTML={{ __html: comment.textShort }}
        />
      )}
      {comment.textShort && (
        <Hyperlink
          className="excerpt_comment__comment__more"
          onClick={commentSummaryClicked}
          {...(accessPremium ? { href: commentUrl, target: '_blank' } : {})}
        >
          {'\u00A0'}
          <FormattedMessage id="search/components/search-results/commentary/SearchResultCommentSummary.tsx/1" />
        </Hyperlink>
      )}
    </div>
  );
};
